import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideModal } from '../redux/features/oxygen/customModalSlice';
import OxyBookLoanModal from './OxyBookLoanModal';
import OxyConfirmMsisdnEmailModal from './OxyConfirmMsisdnEmailModal';
import ConfirmOxygenDetailsUpdate from './ConfirmOxygenDetailsUpdate';
import ClearPrecustomerDetails from './ClearPrecustomerDetails';
import OxygenManualReview from './OxygenManualReview';
import OxygenConfirmBundle from './OxygenConfirmBundle';
import OxygenWaitingModal from './OxygenWaitingModal';
import FBNBundleModal from './FBNBundleModal';

const CustomModalForm = () => {
  const dispatch = useDispatch();
  const { isVisible, formModal } = useSelector((state) => state.customModal);

  const handleClose = () => {
    dispatch(hideModal());
  };

  // Prevent background scrolling when modal is visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  return (
    <>
      {isVisible && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade ${isVisible ? 'show' : ''}`}
        tabIndex="-1"
        aria-hidden={!isVisible}
        style={{ display: isVisible ? 'block' : 'none' }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{formModal?.title}</h5>
              {formModal?.showCloseButton ? (
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleClose}
                ></button>
              ): null}
              
            </div>
            <div className="modal-body">
              {formModal?.type === 'bookLoan' ? (
                <OxyBookLoanModal data={formModal?.data} />
              ) :formModal?.type === 'confirmEmailMsisdn' ? (
                <OxyConfirmMsisdnEmailModal data={formModal?.data} />
              ):formModal?.type === 'confirmOxygenDetailsUpdate' ? (
                <ConfirmOxygenDetailsUpdate data={formModal?.data} />
              ):formModal?.type === 'clearprecustomerDetails' ? (
                <ClearPrecustomerDetails data={formModal?.data} />
              ):formModal?.type === 'manualReview' ? (
                <OxygenManualReview data={formModal?.data} />
              ):formModal?.type === 'confirmBundle' ? (
                <OxygenConfirmBundle data={formModal?.data} />
              ):formModal?.type === 'oxyWaitingModal' ? (
                <OxygenWaitingModal data={formModal?.data} />
              ):formModal?.type === 'fbnBundleModal' ? (
                <FBNBundleModal data={formModal?.data} />
              )
              : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomModalForm;
